<template>
  <div style="height: 100%;">
     <lottie-animation
        style="height: 100%;"
        autoPlay
        loop
        ref="anim"
        :animationData="require('@/assets/loading-animation-credentials.json')"
        @loopComplete="loopComplete"
    />
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue'
export default {
    name: 'LoadingAnimation',
    components:{
        LottieAnimation
    },
    data: ()=>({

    }),
    methods:{
        loopComplete(){
            this.$emit('loopComplete')
        }
    }
}
</script>

<style>

</style>